export const SALUTATIONS = [
    { value: 'MR', label: 'Mr' },
    { value: 'MRS', label: 'Mrs' },
    { value: 'MS', label: 'Ms' },
    { value: 'DR', label: 'Dr.' },
    { value: 'DR_MED', label: 'Dr. med.' },
    { value: 'DR_MED_DENT', label: 'Dr. med. dent.' },
    { value: 'DR_RER_NAT', label: 'Dr. rer. nat.' },
    { value: 'DR_PHIL', label: 'Dr. phil.' },
    { value: 'DR_JUR', label: 'Dr. jur.' },
    { value: 'DR_OEC', label: 'Dr. oec.' },
    { value: 'DR_THEOL', label: 'Dr. theol.' },
    { value: 'DR_HC', label: 'Dr. h.c.' },
    { value: 'DR_HC_MULT', label: 'Dr. h.c. mult.' },
    { value: 'PROF', label: 'Prof.' },
    { value: 'PROF_DR', label: 'Prof. Dr.' },
    { value: 'PD_DR', label: 'PD Dr.' },
    { value: 'MAG', label: 'Mag.' },
    { value: 'MAG_PHARM', label: 'Mag. pharm.' },
    { value: 'MAG_THEOL', label: 'Mag. theol.' },
    // Female
    { value: 'DR_WOMEN', label: 'Frau Dr.' },
    { value: 'DR_MED_WOMEN', label: 'Frau Dr. med.' },
    { value: 'DR_MED_DENT_WOMEN', label: 'Frau Dr. med. dent.' },
    { value: 'DR_RER_NAT_WOMEN', label: 'Frau Dr. rer. nat.' },
    { value: 'DR_PHIL_WOMEN', label: 'Frau Dr. phil.' },
    { value: 'DR_JUR_WOMEN', label: 'Frau Dr. jur.' },
    { value: 'DR_OEC_WOMEN', label: 'Frau Dr. oec.' },
    { value: 'DR_THEOL_WOMEN', label: 'Frau Dr. theol.' },
    { value: 'DR_HC_WOMEN', label: 'Frau Dr. h.c.' },
    { value: 'DR_HC_MULT_WOMEN', label: 'Frau Dr. h.c. mult.' },
    { value: 'PROF_WOMEN', label: 'Frau Prof.' },
    { value: 'PROF_DR_WOMEN', label: 'Frau Prof. Dr.' },
    { value: 'PD_DR_WOMEN', label: 'Frau PD Dr.' },
    { value: 'MAG_WOMEN', label: 'Frau Mag.' },
    { value: 'MAG_PHARM_WOMEN', label: 'Frau Mag. pharm.' },
    { value: 'MAG_THEOL_WOMEN', label: 'Frau Mag. theol.' }
];

export const MATRIAL_STATUS = [
    { value: 'SINGLE', label: 'Single' },
    { value: 'MARRIED', label: 'Married' },
    { value: 'DIVORCED', label: 'Divorced' },
    { value: 'WIDOWED', label: 'Widowed' },
    { value: 'RELATIONSHIP', label: 'In a relationship' },
    { value: 'SEPARATED', label: 'Separated' },
];

export const USER_TYPE = [
    { value: 'INDIVIDUAL', label: 'Individual' },
    { value: 'COMPANY', label: 'Company' },
];

export const GENDERS = [
    { value: 'MALE', label: 'Male' },
    { value: 'FEMALE', label: 'Female' },
    { value: 'OTHER', label: 'Other' },
];

export const PET_TYPES = [
    { value: 'DOG', label: 'Dog' },
    { value: 'CAT', label: 'Cat' },
    { value: 'OTHER', label: 'Other' },
];

export const EVENT_TYPES = [
    { value: 'MEMBER', label: 'Members-only event' },
    { value: 'PARTNER', label: 'Partner event' },
    { value: 'FAMILY', label: 'Family event' },
    { value: 'FRIEND', label: 'Open event' },
];

export const USER_LANGUAGES = [
    { value: 'DE', label: 'Deutsch' },
    { value: 'EN', label: 'English' },
];

export const INFORMATION_TYPES = [
    { value: 'WORKING_HOURS', label: 'Working hours' },
    { value: 'GENERAL', label: 'General' },
    { value: 'WINE', label: 'Wine' },
    { value: 'MENU', label: 'Menu' },
]

export enum USER_STATUS {
    ACTIVE,
    BLOCKED,
    DRAFT,
}

export const COUNTRIES = [
    { value: 'CH', label: 'Switzerland' },
    { value: 'DE', label: 'Germany' },
    { value: 'AT', label: 'Austria' },
    { value: 'FR', label: 'France' },
    { value: 'IT', label: 'Italy' },
    { value: 'GB', label: 'United Kingdom' },
    { value: 'US', label: 'United States' },
    { value: 'RS', label: 'Serbia' },
];

export const ROLES = [
    { value: 'ADMIN', label: 'Admin' },
    { value: 'EXECUTIVE', label: 'Executive' },
    { value: 'EMPLOYEE', label: 'Employee' },
];
